module.exports = "/_next/static/images/23ee3852be39437c292cf6d3f0053670-digital-account-phone-main-screen@sm-1x.png.webp";